<button
  [type]="btnType"
  [class]="'flex items-center justify-center gap-2 ' + class"
  [disabled]="disabled"
  (click)="clickMethod()"
  (mouseenter)="changeMethod()"
>
  <!-- Icon Before -->
  <app-svg-icon
    *ngIf="buttonIconBeforeTextPath"
    [class]="buttonIconBeforeTextCss"
    [name]="buttonIconBeforeTextPath"
    alt=""
  ></app-svg-icon>

  <!-- Text -->
  <span *ngIf="innerText">{{ innerText }}</span>

  <!-- Icon After -->
  <app-svg-icon
    *ngIf="buttonIconAfterTextPath"
    [class]="buttonIconAfterTextCss"
    [name]="buttonIconAfterTextPath"
    alt=""
  ></app-svg-icon>

  <!-- Single Image Mode -->
  <img *ngIf="isImage" [src]="onlyImagePath" alt="" [class]="isImageClass" />
  
  <ng-content></ng-content>
</button>